import { useEffect, useRef } from 'react'
import { ArrowUp } from 'lucide-react'

interface Props {
  value: string
  onChange: (v: string) => void
  onSend: () => void
  placeholder: string
  disabled?: boolean
  busy?: boolean
  sendLabel?: string
  autoFocus?: boolean
  /** Lets the arrow fire on an empty field — used when chips are already selected. */
  canSend?: boolean
}

/** Auto-growing single-field composer. Enter sends, Shift+Enter breaks the line. */
export function Composer({ value, onChange, onSend, placeholder, disabled, busy, sendLabel = 'Send', autoFocus, canSend }: Props) {
  const ready = Boolean(value.trim() || canSend)
  const ref = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    el.style.height = 'auto'
    el.style.height = `${Math.min(el.scrollHeight, 160)}px`
  }, [value])

  return (
    <div className="composer">
      <textarea
        ref={ref}
        rows={1}
        value={value}
        autoFocus={autoFocus}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); if (!busy && ready) onSend() }
        }}
      />
      <button
        className="send"
        onClick={onSend}
        disabled={disabled || busy || !ready}
        aria-label={sendLabel}
      >
        {busy ? <span className="spinner" /> : <ArrowUp size={19} strokeWidth={2.6} />}
      </button>
    </div>
  )
}
